import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-vokaris-teal py-12 text-white">
      <div className="max-w-7xl mx-auto px-6 flex flex-col lg:flex-row justify-between items-center gap-6">
        <div className="flex items-center gap-2 flex-col lg:flex-row">
          <img src="/logo-secondary.svg" className="h-5" alt="Vokaris Logo" />
          <div className="flex gap-8 text-sm text-vokaris-blue/60 lg:ms-10 mt-4 lg:mt-0">
            <Link to="/privacy" className="hover:text-white transition">
              Privacy
            </Link>
            <Link to="/terms" className="hover:text-white transition">
              Terms
            </Link>
            <Link to="/about" className="hover:text-white transition">
              About
            </Link>
            <Link
              to="https://status.vokaris.io"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-white transition"
            >
              Status
            </Link>
          </div>
        </div>

        <div className="text-xs text-vokaris-blue/40">
          &copy; {new Date().getFullYear()} Vokaris Corp. All rights reserved.
        </div>
      </div>
      <div className="max-w-7xl mx-auto px-6 flex flex-col lg:flex-row justify-between items-center gap-6">
        <img src="/logo-binary.svg" />
      </div>
    </footer>
  );
}
